module.exports = __webpack_public_path__ + "img/asus.0277cd2b.png";